exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gw-checkout-timer{position:fixed;right:0;bottom:0;left:0;z-index:10;padding-top:6px;padding-bottom:6px;background-color:#e29824;color:#fff;font-weight:300;text-align:center;text-transform:uppercase}@media (max-width:46.24em){.gw-checkout-timer{font-size:14px}}.gw-checkout-timer__timer{margin-left:12px;font-weight:700}.gw-checkout-timer__timer:before{width:1.125em;height:1.3125em;position:relative;top:-.125em;display:inline-block;background:url(\"data:image/svg+xml;charset=utf8,%3Csvg width='18' height='21' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M-3-1h24v24H-3z'/%3E%3Cpath d='M12 0H6v2h6V0zM8 13h2V7H8v6zm8-6.6L17.4 5c-.4-.5-.8-1-1.4-1.4L14.6 5A9 9 0 0 0 0 12a9 9 0 1 0 16-5.6zM9 19A7 7 0 1 1 9 5a7 7 0 0 1 0 14z' fill='%23FFF'/%3E%3C/g%3E%3C/svg%3E\");background-size:1.125em 1.3125em;content:\"\";vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/checkout-timer/checkout-timer.scss
// module id = XsJg
// module chunks = 1